/**
 * computeBadges
 * Derives profile achievement badges from stats already available on the
 * profile page — no server state. Each tiered category yields at most the
 * highest badge reached, so the list stays short.
 */

// [threshold, emoji, label] per category, highest-first.
const TIERS = {
  posts: [
    [100, '✍️', 'Wordsmith'],
    [50, '📚', 'Prolific'],
    [10, '📖', 'Storyteller'],
    [1, '🖊️', 'First Words']
  ],
  likesReceived: [
    [100, '❤️', 'Beloved'],
    [25, '💗', 'Well-Liked']
  ],
  followers: [
    [100, '👥', 'Popular'],
    [25, '⭐', 'Rising']
  ],
  streak: [
    [30, '🔥', 'Unstoppable'],
    [7, '🔥', 'On Fire'],
    [3, '✨', 'Warming Up']
  ]
};

const DESC = {
  posts: 'posts written',
  likesReceived: 'likes received',
  followers: 'followers',
  streak: 'day writing streak'
};

export function computeBadges(stats = {}) {
  const badges = [];

  for (const key of Object.keys(TIERS)) {
    const value = stats[key] || 0;
    const tier = TIERS[key].find(([threshold]) => value >= threshold);
    if (tier) {
      const [threshold, emoji, label] = tier;
      badges.push({ key, emoji, label, title: `${threshold}+ ${DESC[key]}` });
    }
  }

  if (stats.accountAgeDays >= 365) {
    badges.push({ key: 'veteran', emoji: '🎖️', label: 'Veteran', title: 'Member for over a year' });
  }
  if (stats.isVerified) {
    badges.push({ key: 'verified', emoji: '🌟', label: 'Verified', title: 'Verified account' });
  }

  return badges;
}
